'use strict';

var _toConsumableArray = require('@babel/runtime/helpers/toConsumableArray');
var _slicedToArray = require('@babel/runtime/helpers/slicedToArray');
var _defineProperty = require('@babel/runtime/helpers/defineProperty');
var React = require('react');
var injectSheet = require('react-jss');
var patternImg = require('pobble-components/dist/dev-page/pattern.png');
var api = require('pobble-components/dist/api');
var authHelpers = require('pobble-components/dist/auth-helpers');
var ButtonElement = require('pobble-components/dist/button-element');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _toConsumableArray__default = /*#__PURE__*/_interopDefaultLegacy(_toConsumableArray);
var _slicedToArray__default = /*#__PURE__*/_interopDefaultLegacy(_slicedToArray);
var _defineProperty__default = /*#__PURE__*/_interopDefaultLegacy(_defineProperty);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var injectSheet__default = /*#__PURE__*/_interopDefaultLegacy(injectSheet);
var patternImg__default = /*#__PURE__*/_interopDefaultLegacy(patternImg);
var ButtonElement__default = /*#__PURE__*/_interopDefaultLegacy(ButtonElement);

var _form;
var emoji = ['😂', '❤️', '✨', '🙏', '😍', '😊', '👍', '💕', '👀', '📸', '💥', '💫', '🦍', '🐶', '🦊', '🦁', '🐻', '🐨', '🌈', '🔥', '🤘', '🤌', '👌', '✌️'];
var devPageStyles = {
  container: {
    position: 'absolute',
    left: '0',
    top: '0',
    width: '100%',
    zIndex: '2000'
  },
  greeting: {
    padding: '20px',
    textAlign: 'center',
    backgroundImage: "linear-gradient(180deg, rgba(0, 175, 236, .95), rgba(0, 175, 236, .95)), url(\"".concat(patternImg__default["default"], "\")"),
    backgroundSize: 'auto, 250px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    color: '#fff',
    height: '100vh',
    '& > h2': {
      fontSize: '70px',
      lineHeight: '70px',
      margin: '0 0 10px'
    },
    '& > p': {
      fontSize: '30px',
      lineHeight: '40px',
      letterSpacing: '1px',
      margin: '0'
    }
  },
  login: {
    margin: '16px 0',
    font: 'var(--body)',
    opacity: '.7'
  },
  form: (_form = {
    display: 'none',
    width: '240px',
    margin: '24px auto'
  }, _defineProperty__default["default"](_form, "display", 'grid'), _defineProperty__default["default"](_form, "gap", '16px'), _defineProperty__default["default"](_form, "font", 'var(--body)'), _defineProperty__default["default"](_form, "textAlign", 'center'), _defineProperty__default["default"](_form, '& input', {
    padding: '12px 16px',
    borderRadius: '4px',
    background: '#fff',
    border: 'none',
    width: '100%',
    textAlign: 'center'
  }), _defineProperty__default["default"](_form, '& button', {
    padding: '12px 16px',
    borderRadius: '4px',
    border: 'none',
    background: 'var(--yellow)',
    cursor: 'pointer',
    fontWeight: 'bold'
  }), _form)
};
var DevPage = injectSheet__default["default"](devPageStyles)(function (_ref) {
  var classes = _ref.classes;

  var _useState = React.useState(false),
      _useState2 = _slicedToArray__default["default"](_useState, 2),
      showLogin = _useState2[0],
      setShowLogin = _useState2[1];

  var threeEmoji = React.useMemo(function () {
    return _toConsumableArray__default["default"](Array(emoji.length).keys()).sort(function () {
      return 0.5 - Math.random();
    }).slice(0, 3).map(function (index) {
      return emoji[index];
    });
  }, []);
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.container
  }, /*#__PURE__*/React__default["default"].createElement("div", {
    className: classes.greeting
  }, /*#__PURE__*/React__default["default"].createElement("h2", null, threeEmoji.map(function (emoji) {
    return emoji + ' ';
  })), /*#__PURE__*/React__default["default"].createElement("p", null, "Welcome to Pobble"), !showLogin && /*#__PURE__*/React__default["default"].createElement(ButtonElement__default["default"], {
    onClick: function onClick() {
      return setShowLogin(true);
    },
    className: classes.login
  }, "Sign In"), showLogin && /*#__PURE__*/React__default["default"].createElement("form", {
    onSubmit: function onSubmit(e) {
      e.preventDefault();
      api.apiClient.post('v3/email_authentication', {
        email: e.target.email.value,
        password: e.target.password.value,
        remember_me: true
      }).then(function (res) {
        authHelpers.setToken(res.data.jwt);
        window.location.reload();
      });
    },
    className: classes.form
  }, /*#__PURE__*/React__default["default"].createElement("input", {
    type: "email",
    name: "email",
    placeholder: "Email"
  }), /*#__PURE__*/React__default["default"].createElement("input", {
    type: "password",
    name: "password",
    placeholder: "Password"
  }), /*#__PURE__*/React__default["default"].createElement("button", {
    type: "submit"
  }, "Sign in"))));
});

module.exports = DevPage;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// /codebuild/output/src1478882582/src/pobble-app/client/~/pobble-components/dist/dev-page/index.js